export const emailButtonDataSet = { cy: 'email-button' };
export const passwordButtonDataset = { cy: 'password-button' };
export const continueButtonDataSet = { cy: 'continue-button-sign-in' };
